import DataModel from "shared-src/data/DataModel.js";
import MapPosition from "./MapPosition";
import MediaImage from "./MediaImage";
import TranslatedObject from "shared-src/data/TranslatedObject";

import store from "./store";

export default class PageFokoModel extends DataModel{
    constructor(json) {
        super(json);
        /**
         * Position du foko au sein du royaume
         * @type {MapPosition}
         */
        this.mapPosition=new MapPosition(json.mapposition,this);
        /**
         * Les photos du royaume
         * @type {MediaImage[]}
         */
        this.diaporama=[];
        for(let f of json.diaporama){
            this.diaporama.push(new MediaImage(f));
        }
        /**
         *
         * @type {TranslatedObject}
         */
        this.titletxt=new TranslatedObject(json.title);
        /**
         *
         * @type {TranslatedObject}
         */
        this.peuplementtxt=new TranslatedObject(json.peuplementtxt);
        /**
         *
         * @type {TranslatedObject}
         */
        this.coutumestxt=new TranslatedObject(json.coutumestxt);

        /**
         *
         * @type {PageRoyaumeModel}
         */
        this.royaume=null;
    }

    url(lang){
        if(!lang){
            lang=store.state.language;
        }
        return `/${lang}/foko/${this.id}`;
    }
}